module.exports = __webpack_public_path__ + "img/login-background.e479fe89.jpg";